import React, { useEffect } from 'react';
import { Font, pdf } from '@react-pdf/renderer';

// Register fonts with correct MIME type and format
Font.register({
  family: 'Roboto',
  src: 'https://cdn.jsdelivr.net/npm/@fontsource/roboto@4.5.8/files/roboto-latin-400-normal.woff2',
  fontWeight: 400,
  format: 'woff2',
});

Font.register({
  family: 'Roboto',
  src: 'https://cdn.jsdelivr.net/npm/@fontsource/roboto@4.5.8/files/roboto-latin-700-normal.woff2',
  fontWeight: 700,
  format: 'woff2',
});

interface PDFProviderProps {
  children: React.ReactNode;
}

export function PDFProvider({ children }: PDFProviderProps) {
  useEffect(() => {
    // Initialize PDF renderer safely
    try {
      if (pdf.initialize) {
        pdf.initialize().catch(error => {
          console.error('Failed to initialize PDF renderer:', error);
        });
      }
    } catch (error) {
      console.error('Error during PDF initialization:', error);
    }
  }, []);

  return <>{children}</>;
}